package com.clany.backoffice.data.network

import kotlinx.browser.sessionStorage
import kotlinx.browser.window

actual fun getUrlParam(name: String): String? {
    val search = window.location.search.removePrefix("?")
    return search.split("&")
        .mapNotNull { param ->
            val parts = param.split("=", limit = 2)
            if (parts.size == 2 && parts[0] == name) parts[1] else null
        }
        .firstOrNull()
        ?.takeIf { it.isNotEmpty() }
}

actual fun redirectToUrl(url: String) {
    window.location.href = url
}

actual fun cleanOAuthParams() {
    window.history.replaceState(null, "", window.location.pathname)
}

actual fun storeSessionItem(key: String, value: String) {
    sessionStorage.setItem(key, value)
}

actual fun getSessionItem(key: String): String? =
    sessionStorage.getItem(key)?.takeIf { it.isNotEmpty() }

actual fun removeSessionItem(key: String) {
    sessionStorage.removeItem(key)
}

actual fun getRedirectUri(): String =
    window.location.origin + window.location.pathname
